(() => {

    const { debug, warn } = console;
    const { stringify } = JSON;

    debug(`[ Upsell ]: Starting feature.`)

    window.Upsell ??= {

        async toggle(id) {

            const checkbox = findCheckbox(id);
            const variantId = this.variantId(id)
            const hasItem = checkbox.checked

            debug(`[ Upsell ]: Toggling product in cart ( ${ hasItem } | ${ variantId } )`)

            // A toggle is an add or a remove and then a re-render of the drawer, so the
            // blocker has to span the whole sequence. updateQuantity puts up its own and
            // drops it the moment its request lands, which would leave the drawer live while
            // the sections are still on their way, hence the second enableLoading below.
            // Only worth showing while the drawer is on screen: the auto-add toggles fire on
            // page load with it shut, and would otherwise sheet over the cart page.
            const blocking = findDrawer().classList.contains('active')

            if (blocking) findItemList().enableLoading()

            try {
                if (hasItem)
                    await addUpsellProduct(id)
                else
                    await removeUpsellProduct(variantId)

                if (blocking) findItemList().enableLoading()

                await reloadCart()
                    .catch(() => {
                        window.alert(`Failed to update the cart drawer view, reloading.`)
                        window.location.reload();
                    })
            } finally {
                // Both the remove and the re-render replace <cart-drawer-items>, so the
                // element that has to be cleared is never the one we started with.
                if (blocking) document.querySelector('cart-drawer-items')?.disableLoading()
            }
        },

        variantId(id) {
            return findCheckbox(id).dataset.variant
        },

        variantIds() {
            const checkboxes = document
                .querySelectorAll('.Upsell_Checkbox')

            return [...checkboxes]
                .map((checkbox) => checkbox.dataset.variant)
                .map(Number)
        },

        isCartEmpty(cart) {
            const ids = this.variantIds()


            for (const item of cart.items)
                if (!ids.includes(item.variant_id))
                    return false

            return true
        },

        async emptyCart(cart) {
            debug(`[ Upsell ]: Emptying cart`)

            const variantIds = this.variantIds()

            for (const item of cart.items)
                if (variantIds.includes(item.variant_id))
                    await removeUpsellProduct(item.variant_id)

            closeCart()
        }
    }

    function find(selector) {
        const element = document.querySelector(selector)

        if (element)
            return element

        throw `[ Upsell ]: Upsell element ( ${ selector } ) is missing!`
    }

    function findCheckbox(id) {
        return find(`#Upsell_Checkbox_${ id }`)
    }

    function findDrawer() {
        return find('cart-drawer')
    }

    function findItemList() {
        return find('cart-drawer-items')
    }

    async function removeUpsellProduct(variantId) {
        debug(`[ Upsell ]: Removing Upsell product`)

        const checkbox = document
            .querySelector(`[data-variant='${ variantId }']`)

        const itemList = findItemList()
        const { index } = checkbox.dataset;

        await itemList.updateQuantity(index, 0)
    }

    async function addUpsellProduct(id) {
        debug(`[ Upsell ]: Adding Upsell product`)

        const variantId = Upsell.variantId(id)

        // ✅ FIX: Duplikat-Check
        const cart = await fetch('/cart.js').then(r => r.json())
        const alreadyInCart = cart.items.some(item => String(item.variant_id) === String(variantId))

        if (alreadyInCart) {
            debug(`[ Upsell ]: Product already in cart, skipping duplicate add.`)
            return
        }

        // An upsell only goes in next to a product, never into a cart that holds nothing it
        // could belong to.
        const hasProduct = cart.items.some(item => !item.properties?._is_cart_upsell)

        if (!hasProduct) {
            debug(`[ Upsell ]: No product in cart, skipping add.`)
            return
        }

        const content = {
            items: [{
                quantity: 1,
                id: variantId,
                properties: {
                    _is_cart_upsell: true
                }
            }]
        }

        const request = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: stringify(content)
        }

        const url = routes.cart_add_url + '.js'
        const response = await fetch(url, request)

        if (response.ok)
            return

        window.alert(`Failed to add upsell product`);
    }

    function closeCart() {
        const drawer = findDrawer();
        drawer.close();
    }

    async function reloadCart() {
        const itemList = findItemList()
        const drawer = findDrawer()

        const sections = itemList
            .getSectionsToRender()
            .map((section) => section.section)

        const sectionList = sections.join(',')
        const { pathname } = window.location
        const url = `${ pathname }?sections=${ sectionList }`

        const rendered = await fetch(url)
            .then((response) => response.json())

        drawer.renderContents({ sections: rendered });
    }

})();